
<div class="payment-details-months col-12">
    <div class="row">
        <div *ngFor="let month of playingMonths" class="payment-details-months-cell safari_cell moz_cell col-sm" [ngClass]="{'payment-details-months-cell--active' : month.active == true, 'payment-details-months-cell--inactive' : month.active == 'highlighted'}">
            <p class="safari_p moz_p">{{ month.name }}</p>
        </div>
        <div class="card-option mt-2" *ngIf="fmtOptional" [ngClass]="{'card-option-variant': (this.playingMonths.length === 7 && cardLastSale != null && checkoutState == 3) || isBsAppActive }">
            <ng-container *ngIf="this.playingMonths.length === 7 && cardLastSale != null && checkoutState != 3 && isBsAppActive!==true">
                Når du fortsætter, får du mulighed for at spille med allerede i {{ cardLastSale | date : 'MMMM' }}.
            </ng-container>
            <ng-container *ngIf="isBsAppActive && cardLastSale != null && checkoutState != 3">
                <strong>Dit køb: </strong> 
                    <ng-container *ngIf="order.TicketPackageInstances.length"> 
                        {{order.TicketPackageInstances.length}} lodpakke<ng-container *ngIf="order.TicketPackageInstances.length > 1">r</ng-container> 
                    </ng-container>
                    <ng-container *ngIf="order.Shares.length && order.TicketPackageInstances.length"> og </ng-container>
                    <ng-container *ngIf="order.Shares.length"> 
                        {{order.Shares.length}} lod<ng-container *ngIf="order.Shares.length > 1">der</ng-container> 
                    </ng-container>
                    på betalingsservice til {{orderTotalPrice | money}}
                <br>
                <strong>Tilkøb: </strong>
                    <ng-container *ngIf="order.TicketPackageInstances.length"> 
                        {{order.TicketPackageInstances.length}} lodpakke<ng-container *ngIf="order.TicketPackageInstances.length > 1">r</ng-container> 
                    </ng-container>
                    <ng-container *ngIf="order.Shares.length && order.TicketPackageInstances.length"> og </ng-container>
                    <ng-container *ngIf="order.Shares.length"> 
                        {{order.Shares.length}} lod<ng-container *ngIf="order.Shares.length > 1">der</ng-container> 
                    </ng-container>
                    for 1 måned på kort til {{fmtTotalPrice | money}}
            </ng-container>
        </div>
        
        <!-- help-text for checkout step 3 -->
        <div class="card-option" *ngIf="this.playingMonths.length === 7  && checkoutState === 3"  [ngClass]="{'card-option-variant': (this.playingMonths.length === 7 && cardLastSale != null && checkoutState == 3)}">
            Når du betaler med betalingskort eller MobilePay, bekræfter du, at du spiller med allerede i {{ cardLastSale | date : 'MMMM' }}.
	    </div>
    </div>
</div>
